import type { Libraries } from '@react-google-maps/api';

export const GOOGLE_MAP_KEY = 'AIzaSyAvjlCVEB4r6Q__eN2AinXwxjbNWPPK1BE';

export const GOOGLE_MAPS_LIBRARIES: Libraries = ['places', 'geometry', 'drawing'];

export const ACCESS_TOKEN_KEY = `access-token-${process.env.NODE_ENV}`;